export const IS_DEVELOPMENT = process.env.REACT_APP_ENV === "development";